import { Client, createInstance, enums, setLogger } from '@optimizely/optimizely-sdk';
import logError from 'utils/logError';
import { getOptimizelyUserId } from './OptimizelyHelpers';

setLogger({
  log(level, message) {
    const { LOG_LEVEL } = enums;
    switch (level) {
      case LOG_LEVEL.ERROR:
        logError(message);
        break;
      default:
        break;
    }
  }
});

let instance: Client;

// eslint-disable-next-line import/prefer-default-export
export function getOptimizelyInstance() {
  // disable optimizely on SSR for now; there seem to be some issues with window.document.getElementById() that need to be debugged into
  if (!instance) {
    if (typeof window !== 'undefined') {
      const {
        ipCountry,
        languageRegionCode,
        mobileBrowser,
        optimizelySettings,
        RAILS_ENV,
        store: { user }
      } = global.__AT_DATA__;

      instance = createInstance({
        datafile: optimizelySettings.datafile
      });

      // docs.developers.optimizely.com/experimentation/v4.0.0-full-stack/docs/create-user-context-javascript
      instance.createUserContext(getOptimizelyUserId(), {
        ipCountry,
        isPro: Boolean(user?.pro),
        isSignedIn: !!user,
        locale: languageRegionCode,
        mobileBrowser,
        webEnvironment: RAILS_ENV
      });
    } else {
      instance = {
        activate: () => {},
        isFeatureEnabled: () => {},
        isReady: () => {},
        track: () => {}
      } as unknown as Client;
    }
  }

  return instance;
}
